import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Lightbox } from "../PortfolioPopup/PortfolioPopup";
import "./portfoliobox.css";

const PortfolioBox = ({
    themeData,
    portfolios,
    selectedTheme,
    theme,
    settings,
    sliderRef,
    handlePrev,
    handleNext,
}) => {
    const { t } = useTranslation();
    const [selectedImage, setSelectedImage] = useState(null);
    const [dragging, setDragging] = useState(false);

    const openLightbox = (index) => {
        setSelectedImage(index);
    };

    const closeLightbox = () => {
        setSelectedImage(null);
    };

    // This is for several themes which have different type of dynamic background colors(In box styles they are theme9, theme17 and in open style they are theme35, theme51)
    let dynamicMainBgColor = themeData?.dynamicMainBackgroundColor;
    let dynamicBgColor = themeData?.dynamicBackgroundColor;
    if (theme === 'temp35' || theme === 'temp51') {
        dynamicMainBgColor = themeData?.dynamicBackgroundColor
        dynamicBgColor = themeData?.dynamicMainBackgroundColor
    } else if (theme === 'temp9') {
        dynamicBgColor = `${themeData?.dynamicBackgroundColor}80`
    } else if (theme === 'temp17') {
        dynamicBgColor = `linear-gradient(88.9deg, ${themeData?.dynamicBackgroundColor}, rgba(208, 2, 27, 0.063))`
    }

    const styles = {
        openStyle: {
            background: (selectedTheme?.portfolioType === 'box' ? dynamicBgColor : dynamicMainBgColor) || "",
            padding: selectedTheme?.padding,
            margin: selectedTheme?.margin,
        },
        boxStyle: {
            background: dynamicBgColor || selectedTheme?.bgColor || "",
            padding: selectedTheme?.padding,
            margin: selectedTheme?.margin,
            boxShadow: selectedTheme?.boxShadow,
            borderRadius: selectedTheme?.borderRadius,
        },
        headingStyle: {
            color:
                (selectedTheme?.portfolioType === "open"
                    ? themeData?.dynamicTextHeadingColor
                    : themeData?.dynamicTextDescriptionColor) ||
                (selectedTheme?.portfolioHeadingColor
                    ? selectedTheme?.portfolioHeadingColor
                    : selectedTheme?.headingColor) ||
                "",
            margin: "0 0 15px 0",
            textAlign: selectedTheme?.headingAlign || "center",
        },
        carouselButtonStyle: {
            background: themeData?.dynamicCtaColor || selectedTheme?.btnColor,
            color: themeData?.dynamicCtaTextColor || selectedTheme?.ctaArrow || selectedTheme?.textColor,
        },
    };

    return (
        <article className="gallery sec" style={selectedTheme?.portfolioType === 'open' || selectedTheme?.type === 'open' ? styles.openStyle : styles.boxStyle}>
            <div className="open-header">
                <h3 class="sectitle" style={styles.headingStyle}>
                    {themeData?.headingsObj?.gallery_Heading || themeData?.galleryHeading || t("Portfolio")}{" "}
                </h3>

                <div className={`${theme}-carousel-btn carousel-open`}>
                    <button onClick={handlePrev} style={styles.carouselButtonStyle}>
                        <i className="fa fa-angle-left"></i>
                    </button>
                    <button onClick={handleNext} style={styles.carouselButtonStyle}>
                        <i className="fa fa-angle-right"></i>
                    </button>
                </div>
            </div>

            <div>
                {portfolios.length === 0 ? null :
                    portfolios.length === 1 ? (
                        <div className="portfolio-img-parent-single">
                            <img className="portfolio-img" src={portfolios[0].image} alt="Slide 1" />
                        </div>
                    ) : (
                        <Slider ref={sliderRef} {...settings}>
                            {portfolios.map((slide, index) => (
                                <div
                                    className="portfolio-img-parent"
                                    key={index}
                                    onMouseDown={() => setDragging(false)}
                                    onMouseMove={() => setDragging(true)}
                                    onMouseUp={() => {
                                        if (!dragging) openLightbox(index);
                                    }}
                                    onTouchStart={() => setDragging(false)}
                                    onTouchMove={() => setDragging(true)}
                                    onTouchEnd={() => {
                                        if (!dragging) openLightbox(index);
                                    }}
                                >
                                    <img
                                        className="portfolio-img"
                                        src={slide.image}
                                        alt={`Slide ${index + 1}`}
                                    />
                                </div>
                            ))}
                        </Slider>
                    )
                }

                {selectedImage !== null && (
                    <Lightbox
                        src={portfolios[selectedImage]?.image}
                        slides={portfolios}
                        currentIndex={selectedImage}
                        onClose={closeLightbox}
                        onPrevious={(index) => setSelectedImage(index)}
                        onNext={(index) => setSelectedImage(index)}
                    />
                )}
            </div>
        </article>
    );
};

export default PortfolioBox;